import { dsClass } from '../../../common/constants/dsClasses.js';
import { additionalServicesMsg, t } from '../../../common/i18n/index.js';
import { getLocalizedString } from '../../../common/utils/productOfferingsUtils.js';
import { OfferSpecifications } from '../../HorizontalSubscriptionCard/OfferSpecifications.js';
import { getDefaultModalSpecifications } from '../../ProductOfferingsCardCoCo/ProductOfferingsCardContentCoCo/ProductOfferingCardContentUtils.js';
import type { ProductModalContentProps } from '../../ProductOfferingsCardCoCo/ProductOfferingsCardContentCoCo/types.js';

export const getSoftwareProductModalContent = ({ productOffering, activePopoverRef }: ProductModalContentProps) => {
  const modalSpecs = getDefaultModalSpecifications(productOffering);
  const description = getLocalizedString(productOffering.description);
  return [
    {
      title: t.VY1K('Service details'),
      content: (
        <OfferSpecifications specifications={modalSpecs.voiceAndTextSpecs} activePopoverRef={activePopoverRef} />
      ),
    },
    {
      title: t.LXSR(additionalServicesMsg),
      content: <p className={dsClass.TEXT_S}>{description}</p>,
    },
  ];
};
